import { FunctionComponent } from "react";
import Chip from '@mui/material/Chip';

export const FieldSurfaceSizes: FunctionComponent<{
    sizes: number[]
}> = ({
    sizes,
}) => {
        return (
            <>
                {sizes.map(size => (
                    <Chip
                        sx={{
                            mr: 1
                        }}
                        size="small"
                        component="span"
                        key={size}
                        variant="outlined"
                        label={`${size} x ${size}`}
                    ></Chip>
                ))}
            </>
        )
    }